import { FirebaseDataService } from "../../../../services/firebase-data.service";


const firebaseDataService = new FirebaseDataService();

export function fetchGraphFunnelLeakageFB(statsObj, user, graph) {
  return new Promise(async (resolve, reject) => {
    try {
        firebaseDataService.getStats(statsObj, user, graph, "noncadenceBarchart").subscribe((data) => {
        resolve({ data });
      });
    } catch (error) {
      reject(error);
    }
  });
}


export function fetchFacebookAdsAccounts(URL) {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await fetch(URL);
      let result = await response.json();
      resolve(result);
    } catch (error) {
      reject(error);
    }
  });
}
